// Icons
import AviatorIcon from "assets/icons/glory/aviator.svg?react";
import HOTIcon from "assets/icons/hot.svg?react";

// Url
import url from "url/index";
import { ALIAS_GAME } from "../../types/Banners";

const { VITE_APP_PROJECT_NAME } = import.meta.env;

export enum NAVIGATION_PROPERTIES {
  CATEGORY,
  PROVIDER,
}

export enum TOP_NAVIGATION_DESKTOP_ID_ENUM {
  CASINO,
  LIVE_CASINO,
  V_SPORT,
  TOURNAMENTS,
  AVIATOR,
  GAMES,
  SPORT,
}

export type TopNavigationDesktopTypes = {
  id: number;
  link: string;
  property?: NAVIGATION_PROPERTIES;
  value?: string[];
  category?: string;
  name?: string;
  nameImage?: JSX.Element;
  label?: JSX.Element;
  urlAlias?: string;
};

export const TOP_NAVIGATION_DESKTOP: TopNavigationDesktopTypes[] = [
  {
    id: TOP_NAVIGATION_DESKTOP_ID_ENUM.CASINO,
    link: url.routes.casino.index(),
    name: "header.navbar.casino",
  },
  {
    id: TOP_NAVIGATION_DESKTOP_ID_ENUM.LIVE_CASINO,
    link: url.routes.casino.liveCasino(),
    name: "casino.top.livecasino",
  },
  // {
  //   id: TOP_NAVIGATION_DESKTOP_ID_ENUM.V_SPORT,
  //   link: url.routes.casino.category([CATEGORIES_ENUMS.VSPORT]),
  //   name: "casino.top.vsport",
  // },
  {
    id: TOP_NAVIGATION_DESKTOP_ID_ENUM.TOURNAMENTS,
    link: url.routes.tournament.index(),
    name: "header.navbar.tournament",
  },
  {
    id: TOP_NAVIGATION_DESKTOP_ID_ENUM.GAMES,
    link: url.routes.casino.providers([
      `${VITE_APP_PROJECT_NAME === "banger" ? "Banger" : "Glory"}+Games`,
    ]),
    name: VITE_APP_PROJECT_NAME === "banger" ? "BANGER GAMES" : "GLORY GAMES",
    value: [`${VITE_APP_PROJECT_NAME === "banger" ? "Banger" : "Glory"} Games`],
  },
  {
    id: TOP_NAVIGATION_DESKTOP_ID_ENUM.AVIATOR,
    link: "",
    nameImage: <AviatorIcon />,
    label: <HOTIcon />,
    urlAlias: ALIAS_GAME.AVIATOR,
  },
  {
    id: TOP_NAVIGATION_DESKTOP_ID_ENUM.SPORT,
    link: url.config.casino.sportsBook,
    name: "casino.top.sports",
  },
];
